<template>
  <div>
    <div class="box" v-if="loggedIn">
      <section class="hero is-primary">
        <div class="hero-body">
          <h1 class="title">Welcome, {{ userProperCase }}!</h1>
          <div id="balanceHolder" class="subtitle">
            <CurrentBalance />
          </div>
        </div>
      </section>
      <div id="buttonHolder" class="mt-4">
        <button
          class="button has-text-white"
          type="button"
          id="payOrReqButton"
          @click="navigate"
          style="background-color: #30adef"
        >
          <span class="icon is-small mr-2"
            ><img src="favicon.ico" id="logo" /></span
          >Pay Or Request
        </button>
      </div>
    </div>
    <div id="pendingRequests">
      <PendingRequests />
    </div>
  </div>
</template>

<script>
import CurrentBalance from "../components/CurrentBalance.vue";
import PendingRequests from "../components/PendingRequests.vue";

export default {
  name: "home-page",
  components: {
    CurrentBalance,
    PendingRequests,
  },
  methods: {
    navigate() {
      this.$router.push({ name: "transfer" });
    },
    toProperCase(str) {
      return str.replace(/\w\S*/g, function (txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
      });
    },
  },
  computed: {
    user() {
      return (
        this.$store.state.user.firstName || this.$store.state.user.userName
      );
    },
    loggedIn() {
      return this.$store.state.token.trim().length > 0;
    },
    userProperCase() {
      return this.toProperCase(this.user);
    },
  },

};
</script>
<!-- <style scoped>
.home {
  flex-direction: column;
}
#logo {
  width: 20px;
  height: 20px;
}
#payOrReqButton {
  background-color: #30ADEF;
  color: white;  
  height: 50px;
  width: 200px;
  border-radius: 5px;
  font-size: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center;

}
#buttonHolder {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
#balanceHolder {
  display: flex;
  justify-content: center;
}
</style> -->